import SashiDo from 'lib/SashiDo';

import DropDown from 'components/BoxFieldset/DropDown.react';
import types from 'components/BoxFieldset/Constants';
import CodeSnippet from 'components/CodeSnippet/CodeSnippet.react';
import DashboardView from 'dashboard/DashboardView.react';
import Button from 'components/Button/Button.react';
import ReleaseInfo from 'components/ReleaseInfo/ReleaseInfo';
import Icon from 'components/Icon/Icon.react';
import FileTree from 'components/FileTree/FileTree.react';
import React from 'react';
import history from 'dashboard/history';
import styles from 'dashboard/Data/CloudCode/CloudCode.scss';
import buttonStyles from 'components/Button/Button.scss';
import Toolbar from 'components/Toolbar/Toolbar.react';
import FileTransfer from 'components/FileTransfer/FileTransfer.react';
import CloudCodeStatus from 'components/CloudCodeStatus/CloudCodeStatus.react';
import Notification from 'components/Notification/Notification.react';
import PreLoader from 'components/PreLoader/PreLoader.react';


function getPath(params) {
  return params.splat;
}

export default class CloudCode extends DashboardView {
  constructor(props) {
    super();

    this.section = 'Core';
    this.subsection = 'Cloud Code';

    this.auth = props.currentUser.authData;

    this.state = {
      loading: true,
      files: undefined,
      source: undefined,
      linked_with_github: !!(this.auth && this.auth.github && this.auth.github.id),
      showStartCloudCode: false,
      note: {},
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { query, pathname } = location;
    const { error, ghUser } = query;

    if (error) {
      if (error === '208' && ghUser) {
        // history.replace(pathname);
        this.setState({
          loading: false,
          gitHubUserAlreadyLinked: ghUser,
        });

        return null;
      }
    }

    this.fetchSource(this.context.currentApp, getPath(this.props.params));
    this.handleManageOnGithubClick();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.state.gitHubUserAlreadyLinked) {
      return null;
    }

    if (this.context !== nextContext) {
      this.loadFile(nextContext.currentApp, getPath(nextProps.params));
    }
  }

  fetchSource(app, fileName) {
    app.getLatestRelease()
      .then((release) => {
        this.setState({
          files: release.files, release, source: undefined, loading: false,
        });

        if (!release.files || Object.keys(release.files).length === 0) {
          // Releases is empty. Show EmptyState
          return;
        }

        if (!fileName || release.files[fileName] === undefined) {
          // Means we're still in /cloud_code/. Let's redirect to /cloud_code/main.js
          history.replace(this.context.generatePath('cloud_code/main.js'));
          return;
        }

        this.loadFile(this.context.currentApp, fileName);
      });
  }

  loadFile(app, fileName) {
    this.setState({ source: undefined, loading: true });

    app.getSource(fileName, this.state.release)
      .then((source) => {
        this.setState({ source, loading: false });
      })
      .catch((e) => {
        this.setState({ source: undefined });
      });
  }

  renderSidebar() {
    const current = getPath(this.props.params) || '';
    const { files } = this.state;
    if (!files) {
      return null;
    }

    const paths = [];
    for (const key in files) {
      paths.push(key);
    }

    if (paths.length === 0) {
      return null;
    }

    return (
      <FileTree
        linkPrefix={this.context.generatePath('cloud_code/')}
        current={current}
        files={paths} />
    );
  }

  handleConnectGithubClick() {
    const path = window.location.pathname;
    const { SASHIDO_API_ID } = process.env;
    const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
    const sessionToken = userObject ? userObject.sessionToken : '';
    window.location = `/oauth/github?to=${path}&id=${this.props.currentUser.id}&session=${sessionToken}`;
  }

  handleStartGithubClick() {
    this.setState({ showStartCloudCode: true });

    SashiDo.cloudCodeInit({ appObjectId: this.context.currentApp.id }).then((data) => {
      SashiDo.cloudCodeCollaboratorAdd({ appObjectId: this.context.currentApp.id }).then(() => {
        this.setState({
          CloudCodeStatus: true,
        });
      }).catch((error) => {
        this.setState({ note: { type: 'error', message: error.response.data.error }, showStartCloudCode: false });
      });
    });
  }

  handleManageOnGithubClick() {
    if (!this.state.linked_with_github) {
      return;
    }

    this.context.currentApp.owner_collaborator().then((collab) => {
      if (!collab.authData.github) {
        return SashiDo.cloudCodeCollaboratorAdd({ appObjectId: this.context.currentApp.id });
      }
      return Promise.resolve();
    }).then(() => {
      this.setState({ manageOnGitHub: `https://github.com/parsegroundapps/pg-app-${this.context.currentApp.serviceName}` });
    }).catch((err) => {
      this.setState({ linked_with_github: false });
    });
  }

  renderContent() {
    let startCloudCode = (
      <div className={styles.empty}>
        <div className={styles.connect}>
          {
            this.state.CloudCodeStatus
              ?
                <div className={styles.activate}>
                  <CloudCodeStatus activateView appId={this.props.params.appId} />
                </div>
              :
                <div className={styles.activate}>ACTIVATING</div>
          }
          <div className={styles.cloudCode}>
            <Icon name="icon-cloud-code" width={120} height={120} colored />
            <span className={styles.logo}>
              <img src="/assets/images/logo.svg" width="82" alt="SashiDo" />
            </span>
          </div>
          <div className={styles.transfer}>
            <FileTransfer />
          </div>
          <div className={styles.github}>
            <Icon name="icon-github" width={120} height={120} colored />
          </div>
        </div>
      </div>
    );

    if (this.state.CloudCodeStatus) {
      startCloudCode = (
        <div className={styles.empty}>
          <div className={styles.connect}>
            <CloudCodeStatus activateView appId={this.props.params.appId} />
          </div>
        </div>
      );
    }

    // this is the error returned when your cloud code is disabled
    const cloud_error =
      this.context.currentApp.serverInfo && this.context.currentApp.serverInfo.features && this.context.currentApp.serverInfo.features.cloudCode
        ? this.context.currentApp.serverInfo.features.cloudCode.error
        : null;


    let content = null;
    const fileName = getPath(this.props.params);
    let toolbar = (
      <Toolbar section="Cloud Code" subsection={fileName || (this.state.linked_with_github ? 'Start Cloud Code' : 'Connect to GitHub')} details={ReleaseInfo({ app: this.context.currentApp })}>
        <DropDown items={types.apps__cloud_code} type="toolbar" />
      </Toolbar>
    );

    if (this.state.gitHubUserAlreadyLinked) {
      return (
        <div className={styles.source}>
          {toolbar}
          <PreLoader loading={this.state.loading}>
            <div className={styles.empty}>
              <div className={styles.title}>
                Uh Oh! Something is wrong!
              </div>
              <p>GitHub account <strong>{this.state.gitHubUserAlreadyLinked}</strong> is already connected with another <strong>SashiDo</strong> account!</p>
            </div>
            <Notification note={this.state.note} close />
          </PreLoader>
        </div>
      );
    }

    if (!this.state.files || Object.keys(this.state.files).length === 0) {
      content = (
        <div className={styles.empty}>
          <div className={styles.title}>
            { this.state.linked_with_github ? 'Manage and Deploy your Cloud Code' : 'Connect your account to GitHub' }
          </div>

          { this.state.linked_with_github
            ?
              <Button
                color="green"
                size="big"
                value="Start your Cloud Code"
                onClick={this.handleStartGithubClick.bind(this)} />
            :
              <div className={styles.connectWithGitHub} onClick={this.handleConnectGithubClick.bind(this)}>
                <Icon name="icon-github" width={60} height={60} colored />
                <div className={styles.info}>
                  <div className={styles.name}>Connect to GitHub</div>
                </div>
              </div>
          }
        </div>
      );
    } else if (fileName) {
      Intercom('update', { has_cloud_code: true });

      toolbar = (
        <Toolbar section="Cloud Code" subsection={fileName} details={ReleaseInfo({ app: this.context.currentApp })}>
          <DropDown items={types.apps__cloud_code} type="toolbar" />
          {
              this.state.linked_with_github
                ? <a href={this.state.manageOnGitHub} className={[buttonStyles.button, buttonStyles.green, buttonStyles.fadeIn].join(' ')} target="_blank" rel="noreferrer noopener">
                  <Icon name="icon-github" width={30} height={30} colored />
                  <span>
                      Manage on GitHub
                    <span className={buttonStyles.desc}>You must be logged in to GitHub</span>
                  </span>

                  </a>
                : <Button
                  color="blue"
                  icon="icon-github"
                  iconSize={30}
                  colored
                  value="Connect your account to GitHub"
                  onClick={this.handleConnectGithubClick.bind(this)} />
            }
        </Toolbar>
      );

      const file = this.state.files[fileName];
      const source = this.state.source;
      if (file && source) {
        content = (
          <div className={styles.holder}>
            <div className={styles.code}>
              <CodeSnippet source={source} language="javascript" />
            </div>
            <div className={styles.footer}>
              { cloud_error ? <p className={styles.error}>{cloud_error}</p> : <CloudCodeStatus appId={this.props.params.appId} /> }
            </div>
          </div>
        );
      }
    }

    return (
      <div className={styles.source}>
        {toolbar}
        <PreLoader loading={this.state.loading}>
          {content}
          {this.state.showStartCloudCode ? startCloudCode : null}
          <Notification note={this.state.note} close />
        </PreLoader>
      </div>
    );
  }
}
